import React from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import { Link } from "react-router-dom";
import FooterLandingpage from '../pages/FooterLandingpage';
function Carrer() {
  return (
    <div>
       <Box sx={{ flexGrow: 1 }} >
       <Grid container spacing={2} style={{backgroundColor:'#232f3e',padding:'12px 24px'}}>
        <Grid item xs={12} md={10} >
        <Typography variant="h1" gutterBottom style={{textAlign:"left",fontWeight: 700,
  fontSize:' 2.5rem',
  lineHeight: '1.2',
  color:'#fff',marginTop:'50px'}}>
       Find jobs
       </Typography>
       <Grid item xs={12} md={10} sx={{display:'flex',justifyContent:'center',alignItems:'center',gap:'50px','@media (max-width: 490px)': {
    flexDirection:'column',
    gap:'20px'
  },}}>
       <TextField id="standard-basic"   sx={{width: { xs: '100%', md: '45%' },
      '& .MuiInputBase-input': { 
        color: 'gray',
        fontSize: '25px', // Set the font size to your desired value
    },
    }}   placeholder=" Search for jobs by title or keyword" variant="standard" />
  <TextField id="standard-basic" placeholder="Location" sx={{width: { xs: '100%', md: '30%' },
  '& .MuiInputBase-input': {
    fontSize: '20px', // Set the font size to your desired value
},}} 
  InputProps={{
    startAdornment: (
        <InputAdornment position="end"> 
            <LocationOnIcon/>
        </InputAdornment>
    ),
}}

  variant="standard"
  />
     </Grid>
      
     
        </Grid>
        </Grid>
        <Grid container spacing={1} sx={{padding:'80px',backgroundColor:'#eaedf2'}}>
       <Grid item xs={12} md={4}>
       <Card sx={{ Width: 200,marginBlock:'10px',height:'37vh'}}>
      <CardContent>
        
        <Typography variant="h4" component="div" sx={{textAlign:'center'}} >
        Opportunities for students
        </Typography>
        
        <Typography variant="h6" component="div" sx={{textAlign:'center'}}>
        Learn about, search for, and apply to<br/> internships and full-time opportunities for <br/> students.
             
        </Typography>
      </CardContent>
      <CardActions>
      <Button variant="outlined" disabled sx={{ width: { xs: '100%', md: '100%' },backgroundColor:'transparent',color:'#232f3e  ',borderColor:'#232f3e','&:hover': {
      backgroundColor: '#232f3e',
      color: 'white',
    } }}>View Open Jobs</Button>
      </CardActions>
    </Card>
       </Grid>
       <Grid item xs={12} md={4} >
       <Card sx={{ Width: 200,marginBlock:'10px',height:'37vh' }}>
      <CardContent>
        
        <Typography variant="h4" component="div" sx={{textAlign:'center'}} >
        Warehouse and hourly jobs
        </Typography>
        
        <Typography variant="h6" component="div" sx={{textAlign:'center'}}>
        Search open jobs and learn about job<br/> opportunities at  warehouses and <br/>stores.
             
        </Typography>
      </CardContent>
      <CardActions>
      <Button variant="outlined" disabled sx={{ width: { xs: '100%', md: '100%' },backgroundColor:'transparent' }}>Outlined</Button>
      </CardActions>
    </Card>
       </Grid>
       <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column' }} >
       <Card sx={{ Width: 200,marginBlock:'10px',height:'37vh' }}>
      <CardContent>
        
        <Typography variant="h4" component="div" sx={{textAlign:'center'}} >
        Software Development
        </Typography>
        
        <Typography variant="h6" component="div" sx={{textAlign:'center'}}>
        Explore job opportunities and<br/> what it's like<br/> to be a software engineer at MegaConnect.
             
      </Typography>
      </CardContent>
      <CardActions>
      <Link to='/software-development' style={{ width:'100%',marginTop:'10px' }}><Button variant="outlined" sx={{ width: { xs: '100%', md: '100%' },backgroundColor:'transparent',color:'#232f3e  ',borderColor:'#232f3e','&:hover': {
      backgroundColor: '#232f3e',
      color: 'white',
    } }}>View Open Jobs</Button></Link>
      </CardActions>
    </Card>
       </Grid>
       </Grid>
        
        <Grid container spacing={1} sx={{padding:'80px',backgroundColor:'#005276'}} >
        <Grid item xs={12} md={6} sx={{marginLeft: { xs: '0', md: '80px' }}}>
        <Typography variant="h3" gutterBottom sx={{fontWeight:900,color:'#fff'}}>
        Come build the future with us
      </Typography>
      <Typography variant="body1" gutterBottom  sx={{color:'#fff'}}>
        body1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
        blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur,
        neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum
        quasi quidem quibusdam.
      </Typography>
      <Button variant="outlined"  sx={{
    width: { xs: '50%', md: '50%' },
    backgroundColor: 'transparent',
    marginBlock: '12px 24px',
    color: 'white',
    borderColor: 'white',  // Set border color to white
    '&:hover': {
      backgroundColor: 'white',
      color: '#005276',
    },
  }}>Learn More</Button>
        </Grid>
        </Grid>
      <FooterLandingpage/>
      </Box>
    </div>
  )
};

export default Carrer;
